import { render, staticRenderFns } from "./LoginWrapper.vue?vue&type=template&id=c1a58b9e&"
import script from "./LoginWrapper.vue?vue&type=script&lang=js&"
export * from "./LoginWrapper.vue?vue&type=script&lang=js&"
import style0 from "./LoginWrapper.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports